import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import MarkerClusterer, {
  MarkerClustererOptions,
} from '@googlemaps/markerclustererplus';
/// <reference types="@types/googlemaps" />
import { MemberLocation } from './../member-location.model';
import { MemberService } from '../../services/member.service';
import Long from 'long';

@Component({
    selector: 'app-members-on-cluster',
    templateUrl: './members-on-cluster.component.html',
    styleUrls: ['./members-on-cluster.component.scss'],
    standalone: false
})
export class MembersOnClusterComponent implements AfterViewInit {
  @ViewChild('map') mapElement: any;
  @Input() contactsArr: number[];
  memberLocArr: MemberLocation[];
  isLoading: boolean = true;
  map: google.maps.Map;
  markers: google.maps.Marker[];
  currentPosition = {
    lat: 0,
    lng: 0,
  };

  constructor(private memberService: MemberService) {}

  async ngAfterViewInit() {
    this.memberLocArr = await this.memberService.getMemberLocations(
      this.contactsArr
    );
    if (this.memberLocArr.length == 0) {
      this.isLoading = false;
      return;
    }

    this.isLoading = false;

    const mapProperties = {
      center: new google.maps.LatLng(
        this.currentPosition.lat == 0
          ? this.memberLocArr[0].latitude
          : this.currentPosition.lat,
        this.currentPosition.lng == 0
          ? this.memberLocArr[0].longitude
          : this.currentPosition.lng
      ),
      zoom: 10,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    this.map = new google.maps.Map(
      this.mapElement.nativeElement,
      mapProperties
    );

    this.addMarkers();
  }

  addMarkers() {
    var clusterOptions = {
      imagePath:
        'https://raw.githubusercontent.com/googlemaps/js-marker-clusterer/gh-pages/images/m',
    };

    var localmap = this.map;

    const infoWindow = new google.maps.InfoWindow({
      content: '',
      disableAutoPan: true,
    });

    const locations = this.memberLocArr.map((a) => {
      return { lat: a.latitude, lng: a.longitude };
    });

    const markers = locations.map((position, i) => {
      var label = '';
      const marker = new google.maps.Marker({
        position,
        label,
      });

      // marker.addListener('click', () => {
      //   infoWindow.setContent(label);
      //   infoWindow.open(localmap, marker);
      // });

      return marker;
    });

    new MarkerClusterer(localmap, markers, clusterOptions);
  }

  isIOS() {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      return true;
    } 
    return false; 
  }
}
